<template>
  <transition name="slide-left" >
    <CommonPopup 
      class="J-evaluate-list"
      v-show="isShow" 
      @close="closeFn" 
      :title="'评价'+likePercentChange" 
      :listenScroll="true" 
      @scroll="handleScroll" 
      ref="evaluatePop"
      :pageError="pageError" 
      :menu="false" 
      :fixFlag="fixFlag" 
      v-backFn="{ show: isShow, closeFn: 'closeFn' }"
      >
      <template v-slot:headerExtra>
        <tab-list :tabList="tabList" :tagId="curTagId" @tabFilterRemarkList="labelFilterRemarkList"></tab-list>
      </template>
      <div ref="listRef" class="list-content evaluate-list-content" :class="[isLowAndroid ? 'list-content-low' : '', floatTips ? 'float-tips-pd' : '']">
        <!-- tab -->
        <div id="list" class="list">
          <!-- 标签 -->
          <label-list :labels="labels" :tagId="curTagId" @labelFilterRemarkList="labelFilterRemarkList" ref="labelListRef"></label-list>
          <!-- 版本选择和排序选择模块 -->
          <div class="spu-select-container" v-if="showSelect">
            <div class="spu-select-box">
              <!-- 选择版本 -->
              <div class="spu-select">
                <div @click="showVersionPopup" v-if="isValid">
                  <span class="spu-name">{{ selectedText || '选版本' }}</span>
                  <span class="icon-arrow"></span>
                </div>
              </div>
              <!-- 选择排序 -->
              <div class="sort-select">
                <span :class="sortOrder == '' ? 'selected' : 'unselected'" @click="sortFilterRemarkList('', '默认排序')">
                  默认排序
                </span>
                <span class="line"></span>
                <span :class="sortOrder == 'desc' ? 'selected' : 'unselected'"
                  @click="sortFilterRemarkList('desc', '最新排序')">
                  最新排序
                </span>
              </div>
            </div>
          </div>
          <!--评价列表-->
          <div class="evaluate-list">
            <template v-if="!first">
              <div class="product__evaluation__default" v-if="(remarkList || []).length == 0">
                <v-empty type="content" description="暂无评论，赶紧购买进行评论吧~"></v-empty>
                <!-- <div class="icon-no-evaluation"></div>
                <div class="text">暂无评论，赶紧购买进行评论吧~</div> -->
              </div>
              <!-- 评论信息 -->
              <comment-card v-for="(remarkItem, index) in remarkList" :key="index" :remarkItem="remarkItem"
                @previewAll="previewAll" @upvote="upvote" @preview="preview"></comment-card>
            </template>
            <template v-else>
              <!-- 加载中 -->
              <v-list-loading class="no-info" />
            </template>
          </div>
        </div>
        <!--滚动加载-->
        <div id="more" v-show="(remarkList || []).length != 0">
          <v-loading-more :isLoading="hasNext" />
        </div>
        <div @click="toTop" v-show="showToTop" class="back-top"></div>
        <div @click="toQuestion" v-track="[
          {
            act: 'show',
            params: {
              cfrom: '105|007|02|077',
              event_id: '105|007|02|077',
              sku_id: skuSelectId || skuId
            }
          },
          {
            act: 'click',
            params: {
              cfrom: '105|007|01|077',
              event_id: '105|007|01|077',
              sku_id: skuSelectId || skuId
            }
          }
        ]" class="question-icon"></div>
        <template v-if="isValid">
          <SelectVersionPopup ref="selectVersionPopup" :isShow="showVersion" @close="closeVersionPopup"></SelectVersionPopup>
        </template>
      </div>
    </CommonPopup>
  </transition>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import CommonPopup from '../../../common-popup'
import { getRemarkList, giveLike } from '../../../../index/api'
import env from 'utils/clientEnv'
import LabelList from '../label-list'
import TabList from '../tab-list'
import CommentCard from '../comment-card'
import SelectVersionPopup from '../select-version-popup'
import clientEnv from '@/utils/clientEnv'
import { app } from '@/utils'
export default {
  name: 'EvaluateList',
  components: {
    CommonPopup,
    LabelList,
    CommentCard,
    TabList,
    SelectVersionPopup
  },
  props: {
    isShow: Boolean,
    tagId: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    ...mapState('detailv3', ['spuInfo']),
    ...mapGetters('detailv3', ['spuId', 'skuId', 'goodsType', 'floatTips']),
    remarkPreviewList() {
      return this.remarkList.filter(item => item?.commentListPics?.length)
    },
    specItem() {
      return this.spuInfo.specItem
    },
    isValid() {
      // 只有版本和颜色的时候才支持选择
      let specMainSeqArr = Object.values(this.specItem.specMainSeq)
      if (specMainSeqArr.length === 2 && specMainSeqArr.includes('颜色') && specMainSeqArr.includes('版本')) {
        return true
      } else {
        return false
      }
    },
    likePercentChange() {
      return this.likePercent ? `（${this.formateLikePercent(this.likePercent)}%好评）` : ''
    }
  },
  data() {
    return {
      pageError: false,
      isLowAndroid: env.isLowAndroid,
      isUpvote: false,
      curTagId: '',
      lastId: '', // 列表返回的最后一条数据的commentId，用于下一页数据查询
      pageNum: 1,
      pageSize: 15,
      // 评论信息
      remarkList: [],
      previewRemarkList: [],
      sortOrder: '', // 评价列表排序规则，默认为运营干预后，降序为'desc'，升序为'asc'
      // 是否为第一次请求
      first: true,
      isAppSupportVideo: !env.isVivoApp || env.appVersion >= 3950 || env.isIOSVivoApp, // 判断官网app是否支持评价图片预览
      startTime: Date.now(),
      hasNext: true, //是否存在下一页
      showToTop: false,
      showVersion: false,
      selectedText: '',
      labels: [],
      tabList: [],
      skuSelectId: null,
      showSelect: false,
      likePercent: 0, //好评度
      fixFlag: true,
      isLoading: false,
      isShowList: false,
      backOut: false,
      oldScollTop: 0,
      nativeHeight: 0,
      listPopFirstEnter: true
    }
  },
  created() {
    this.curTagId = this.tagId
    this.$track({
      cfrom: '105|001|55|077',
      event_id: '105|001|55|077',
      goodtype: this.goodsType,
      sku_id: this.skuId
    })
    // window.addEventListener('scroll', e => this.debounce(this.getMore, 100)(e))
    this.getRemarkList(true)
    // if (clientEnv.isIOSVivoApp) {
    //   app.getTitleBarHeight({
    //     type: 'statusBarHeight',
    //     success: res => {
    //       this.nativeHeight = res
    //     }
    //   })
    // } else {
    //   app.getTitleBarHeight({
    //     type: 'navBarHeight',
    //     success: res => {
    //       this.nativeHeight = ((res * window.screen.width) / (100 * 720))* 150 / 100 + 'rem'
    //     }
    //   })
    // }
  },
  destroyed() {
    // window.removeEventListener('scroll', e => this.debounce(this.getMore, 100)(e))
  },
  mounted() { },
  // 再次从商详页点击标签过滤
  watch: {
    // nativeHeight: {
    //   immediate: true,
    //   handler(val) {
    //     if (!this.fixFlag && this.isShowList) {
    //       document.getElementById('list').style.marginTop = val
    //     }
    //   }
    // },
    isShow: {
      handler(val) {
        if (val) {
          // this.backOut = false
          // this.isShowList = true
          // this.oldScollTop = document.documentElement.scrollTop || document.body.scrollTop
          // this.startTime = Date.now()
          // setTimeout(() => {
          //   this.fixFlag = false
          this.SET_IS_SHOW_REMARK_POPUP(true)
          document.body.classList.add('v-overflow-hidden')
          //   document.documentElement.scrollTop = 0
          //   document.body.scrollTop = 0
          //   document.getElementById('list').style.marginTop = this.nativeHeight
          // }, 300)
        } else {
          // document.getElementById('list').style.marginTop = '0px'
          // document.getElementById('app').style.position = 'fixed'
          // document.getElementById('app').style.top = `-${this.oldScollTop}px`
          // this.fixFlag = true
          // this.backOut = true
          this.SET_IS_SHOW_REMARK_POPUP(false)
          document.body.classList.remove('v-overflow-hidden')
          // setTimeout(() => {
          //   document.getElementById('app').style.removeProperty('position')
          //   document.getElementById('app').style.removeProperty('top')
          //   document.documentElement.scrollTop = this.oldScollTop
          //   document.documentElement.scrollTop || (document.body.scrollTop = this.oldScollTop)
          // }, 140)
          // setTimeout(() => {
          //   let scollValue = document.documentElement.scrollTop || document.body.scrollTop
          //   if (this.oldScollTop - 50 > scollValue || scollValue > this.oldScollTop + 50) {
          //     document.getElementById('remark').scrollIntoView({ behavior: 'smooth', block: 'center' })
          //   }
          //   this.isShowList = false
          // }, 500)
          this.leaveTrack()
        }
        if (val && this.curTagId != this.tagId) {
          this.sortOrder = ''
          this.skuSelectId = null
          this.selectedText = ''
          this.labelFilterRemarkList(this.tagId, '', true)
          if (this.isValid) {
            this.$refs.selectVersionPopup.clearSelectIndex()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('detailv3', ['SET_IS_SHOW_REMARK_POPUP']),
    formateLikePercent(value) {
      if (value == 1) {
        return 100
      } else {
        let result = Math.round(value * 1000) / 10
        if (result == 100) {
          return 99.9
        } else {
          return result
        }
      }
    },
    labelShowTrack(labels) {
      let labelName = []
      labels.forEach(el => {
        labelName.push(el.tagName)
      })
      this.$track({
        cfrom: '105|004|02|077',
        event_id: '105|004|02|077',
        tag_content: labelName.toString().replaceAll(',', '|'),
        sku_id: this.skuId,
        spu_id: this.spuId
      })
    },
    closeVersionPopup(data) {
      this.showVersion = false
      if (data) {
        if (data.selectedText != ' ') {
          this.selectedText = data.selectedText
        } else {
          this.selectedText = ''
        }
        if (this.skuSelectId != data.skuId) {
          this.curTagId = ''
          this.pageNum = 1
          this.lastId = ''
          this.first = true
          this.sortOrder = ''
          this.hasNext = true
          this.skuSelectId = data.skuId
          this.remarkList = []
          this.getRemarkList(true, true)
          this.$emit('updateId', this.curTagId)
        }
      }
    },
    showVersionPopup() {
      this.$track({
        cfrom: '105|005|01|077',
        event_id: '105|005|01|077',
        sku_id: this.skuSelectId || this.skuId
      })
      this.showVersion = true
    },
    toQuestion() {
      const paramSku = this.skuSelectId ? (this.skuSelectId + '').split(',')[0] : this.skuId
      app.openNewWebview({
        url: `${this.linkBase}/product/qa/list?spuId=${this.spuId}&skuId=${paramSku}`
      })
    },
    toTop() {
      this.showToTop = false
      this.$refs.labelListRef?.$el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      // document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    // 防抖
    // debounce(fn, wait) {
    //   var timeout = null
    //   return function () {
    //     if (timeout !== null) clearTimeout(timeout)
    //     timeout = setTimeout(fn, wait)
    //   }
    // },
    handleScroll(e){
      // 显示返回顶部按钮
      const scrollTop = e.target.scrollTop
      const offsetHeight = e.target.offsetHeight
      if (scrollTop >= 500) {
        this.showToTop = true
      } else {
        this.showToTop = false
      }
      if (this.isReachBottom(scrollTop, offsetHeight)) {
        this.getMore()
      }
    },
    isReachBottom(scrollT, containerH) {
      const listRef = this.$refs.listRef
      const eleH = listRef.offsetHeight
      return scrollT + containerH + 100 > eleH
    },
    // 判断是否在视口
    // isInViewPortOfTwo(el) {
    //   if (!el) {
    //     return false
    //   }
    //   const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    //   const top = el.getBoundingClientRect() && el.getBoundingClientRect().top
    //   return top <= viewPortHeight + 1000
    // },

    getMore() {
      // if (this.isShowList && !this.fixFlag) {
        
        // let isShow = this.isInViewPortOfTwo(document.getElementById('more'))
        if (this.hasNext && !this.isLoading) {
          this.pageNum = this.pageNum + 1
          this.getRemarkList()
        }
      // }
    },
    /**
     * 分页获取评价数据
     */
    async getRemarkList(trackFlag = false, isReset = false) {
      if (!this.isLoading) {
        this.isLoading = true
        let _params = {
          spuId: this.spuId,
          tagId: this.curTagId, // 最新的tagId重置为空
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          sortOrder: this.sortOrder,
          type: 2 //列表页评价
        }
        if (this.skuSelectId) {
          _params.skuIds = this.skuSelectId
        }
        if (this.lastId) {
          _params.lastId = this.lastId
        }
        try {
          this.pageError = false
          let _data
          if(this.listPopFirstEnter){
            const firstPopAniPromise = new Promise((resolve)=>{
              setTimeout(()=>{
                resolve()
              }, 300)
            })
            let resultArr = await Promise.all([getRemarkList(_params), firstPopAniPromise])
            _data = resultArr[0]
            this.listPopFirstEnter = false
          } else {
            _data = await getRemarkList(_params)
          }

          if (this.pageNum == 1) {
            this.labels =
              _data?.commentLabels
                ?.filter(el => {
                  return el.evaluateNum
                })
                .slice(0, 6) || []
            let param = {}
            param.tagName = '全部'
            param.evaluateNum = _data.tagCommentsAmount
            param.tagId = ''
            this.tabList = _data?.categoryLabels || []
            this.tabList.unshift(param)
          }
          // 评价标签曝光埋点（仅在进入列表页和版本切换时曝光）
          if (trackFlag && this.labels) {
            this.labelShowTrack(this.labels)
          }
          let curList = []

          if (_data?.commentDetailsPage?.list?.length) {
            curList = _data.commentDetailsPage.list
          }
          // 重复判断，避免由于快速点击造成数据重复
          if (this.curTagId == _params.tagId) {
            if (_data?.lastId) {
              this.lastId = _data.lastId
            }
            this.hasNext = _data?.commentDetailsPage?.hasNext
            this.likePercent = _data?.likePercent
            if (isReset) this.remarkList = []
            this.remarkList = this.remarkList.concat(curList)
          }
          this.first = false
          this.showSelect = true
        } catch (error) {
          this.pageError = true
        }
        this.isLoading = false
      }
    },
    upvote(remarkItem) {
      if (!this.isUpvote) {
        this.isUpvote = true
        if (!remarkItem.myLike) {
          let params = {
            likeType: 1,
            commentId: remarkItem.commentId,
            type: 2,
            topicId: this.spuId
          }
          giveLike(params)
            .then(data => {
              remarkItem.myLike = true
              remarkItem.likeNum++
              this.isUpvote = false
            })
            .catch(e => {
              if (e.msg) {
                this.$toast(e.msg)
              }
              this.isUpvote = false
            })
        } else {
          let params = {
            likeType: 2,
            commentId: remarkItem.commentId,
            type: 2,
            topicId: this.spuId
          }
          giveLike(params)
            .then(data => {
              remarkItem.myLike = false
              remarkItem.likeNum--
              this.isUpvote = false
            })
            .catch(e => {
              if (e.msg) {
                this.$toast(e.msg)
              }
              this.isUpvote = false
            })
        }
      }
    },

    /**
     * 图片预览
     * @param {Number} startPosition - 当前点击图片索引
     * @param {Object} remarkItem - 评价图片列表
     * @param {Number} idx - 追加评论的索引
     */
    preview(startPosition, remarkItem, idx) {
      this.$emit('preview', startPosition, remarkItem, idx)
    },
    // 预览所有评价图片
    previewAll(startPosition, remarkItem) {
      this.$track({
        source: 'comment',
        cfrom: '106|001|01|077',
        event_id: '106|001|01|077',
        comment_id: remarkItem.commentId,
        stateval: remarkItem.commentListPics[0].videoUrl ? 1 : 2
      })
      let curIndex = -1
      this.remarkPreviewList.forEach((item, index) => {
        if (remarkItem.commentId == item.commentId) {
          curIndex = index
        }
      })
      this.$emit(
        'previewAll',
        startPosition,
        remarkItem,
        curIndex,
        this.curTagId,
        this.pageNum,
        this.lastId,
        this.remarkPreviewList
      )
    },
    /**
     * 关闭弹框
     */
    closeFn() {
      this.$emit('close', false)
    },
    // 排序筛选
    sortFilterRemarkList(sortOrder, label_name) {
      if (this.sortOrder !== sortOrder && !this.isLoading) {
        this.$track({
          cfrom: '105|006|01|077',
          event_id: '105|006|01|077',
          order: label_name,
          sku_id: this.skuSelectId || this.skuId
        })
        this.sortOrder = sortOrder
        this.filterRemarkList(null, sortOrder, label_name, false, true)
      }
    },
    // 标签筛选
    labelFilterRemarkList(tagId, label_name, trackFlag = false) {
      if (this.curTagId !== tagId) {
        this.filterRemarkList(tagId, null, label_name, trackFlag, true)
      } else {
        this.toTop()
      }
    },
    // 筛选标签
    // isReset：防止连续快速点击标签进行筛选导致数据显示错误
    filterRemarkList(tagId, sortOrder, label_name, trackFlag, isReset = false) {
      if (!this.isLoading) {
        this.first = true
        this.curTagId = tagId === '' ? '' : tagId || this.curTagId
        this.pageNum = 1
        this.lastId = ''
        this.remarkList = []
        this.hasNext = true
        this.sortOrder = sortOrder || this.sortOrder
        this.getRemarkList(trackFlag, isReset)
        this.$emit('updateId', this.curTagId)
        this.toTop()
      }
    },
    toggleMoreLabel() {
      this.isShowMoreLabels = !this.isShowMoreLabels
    },
    leaveTrack() {
      this.$track({
        cfrom: '105|001|98|077',
        event_id: '105|001|98|077',
        goodstype: this.goodsType,
        sku_id: this.skuId,
        duration: Date.now() - this.startTime
      })
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>